module.exports = `${require.publicPath}102.5c0c90da.png`;